import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <NFLTemplate
    {...props}
    team="Tampa Bay Buccaneers"
    teamShort="Buccaneers"
    teamId={teamIds['Tampa Bay Buccaneers']}
  />
)
